import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, tap } from 'rxjs';
import { RefusedActions } from './refused.actions';

@Injectable({
  providedIn: 'root'
})
export class RefusedEffects {
  sendRefusedEffect$: Observable<Action>;

  constructor(private actions$: Actions) {
    this.sendRefusedEffect$ = createEffect(
      (): any =>
        this.actions$.pipe(
          ofType(RefusedActions.submitSuccess),
          tap(() => {})
        ),
      { dispatch: false }
    );
  }
}
